import styled from '@emotion/styled';
import { Text } from '../../../../';
import { stylesForDefaultState } from '../../../../_internal/theme/stylesFor';

const BaseThemeText = styled(Text)`
  ${stylesForDefaultState('select')}
`;

export default BaseThemeText;
